import BudibaseEmitter from "./BudibaseEmitter"

const emitter = new BudibaseEmitter()

export { init } from "./docUpdates"
export default emitter
